export type AdminRouteId =
  | "supportFeedback"
  | "dashboard"
  | "stores"
  | "storeDetail"
  | "installationHistory"
  | "integrationHealth"
  | "failedJobs"
  | "dataBrowser"
  | "usage"
  | "audit";

export interface AdminRouteDefinition {
  readonly id: AdminRouteId;
  readonly label: string;
  readonly path: string;
  readonly permission: string;
  readonly supportAccessBanner?: boolean;
}

export const ADMIN_ROUTES: readonly AdminRouteDefinition[] = [
  {
    id: "dashboard",
    label: "Operations",
    path: "/admin",
    permission: "admin.operations_health.read",
  },
  { id: "stores", label: "Stores", path: "/admin/stores", permission: "admin.stores.read" },
  {
    id: "storeDetail",
    label: "Store detail",
    path: "/admin/stores/:storeHash",
    permission: "admin.stores.read",
    supportAccessBanner: true,
  },
  {
    id: "installationHistory",
    label: "Installation history",
    path: "/admin/stores/:storeHash/installations",
    permission: "admin.installations.read",
    supportAccessBanner: true,
  },
  {
    id: "integrationHealth",
    label: "Integration health",
    path: "/admin/health",
    permission: "admin.extraction_health.read",
  },
  {
    id: "failedJobs",
    label: "Failed jobs",
    path: "/admin/jobs/failed",
    permission: "admin.jobs.read",
  },
  {
    id: "dataBrowser",
    label: "Data browser",
    path: "/admin/data-browser",
    permission: "admin.data_browser.read",
  },
  { id: "usage", label: "Usage", path: "/admin/usage", permission: "admin.usage.read" },
  { id: "audit", label: "Audit", path: "/admin/audit", permission: "admin.audit.read" },
  {
    id: "supportFeedback",
    label: "Support & Feedback",
    path: "/admin/feedback",
    permission: "admin.feedback.read",
  },
] as const;

export function routeById(id: AdminRouteId): AdminRouteDefinition {
  const route = ADMIN_ROUTES.find((candidate) => candidate.id === id);

  if (route === undefined) {
    throw new Error("Unknown admin route");
  }

  return route;
}
